import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'propertyValue',
})
export class PropertyValuePipe implements PipeTransform {

  transform(value: any, ...args) {
    const datePipe = new DatePipe('en-US');
    const property = {... value};
    switch (property.name) {
      case 'Baujahr':
        if (property.value && property.value !== '') {
          property.value = datePipe.transform( property.value, 'yyyy' );
        }
        break;
    }

    return property;
  }

}
